import { render, staticRenderFns } from "./DataScience.vue?vue&type=template&id=2fc1d28d&scoped=true&"
import script from "./DataScience.vue?vue&type=script&lang=js&"
export * from "./DataScience.vue?vue&type=script&lang=js&"
import style0 from "./DataScience.vue?vue&type=style&index=0&id=2fc1d28d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1d28d",
  null
  
)

export default component.exports